import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type PortLogEPSCoverPageProps = PropsFromRedux & OwnProps;
function PortLogEPSCoverPage(props: PortLogEPSCoverPageProps) {
    const { vesselInfo, selectedDate } = props;
    const portLogData = {
        firstPage: {
            mt: vesselInfo?.vesselName ?? '',
            callSign: vesselInfo?.callSign ?? '',
            officialNo: vesselInfo?.imoNumber ?? '',
            periodFrom:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
            periodTo:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
        },
    };

    const { firstPage } = portLogData;
    const { mt, callSign, officialNo, periodFrom, periodTo } = firstPage;

    return (
        <>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">PORT LOG BOOK</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {mt}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Official No:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodFrom}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodTo}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left print-page-break print:pt-6">
                <h2 className="uppercase text-2xl font-semibold text-center">
                    Instructions
                </h2>
                <p className="my-4">
                    This log book shall be used to record the following:
                </p>
                <ol className="list-decimal ml-4">
                    <li className="my-2 mx-0">
                        All events that take place from FWE at arrival port till
                        SBE at departure port.
                    </li>
                    <li className="my-2 mx-0">
                        The Vessels Arrival and Departure draft.
                    </li>
                    <li className="my-2 mx-0">
                        Dock water density upon arrival in port.
                    </li>
                    <li className="my-2 mx-0">
                        Time gangway lowered to the jetty or shore gangway
                        placed on board.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, timings pertaining to cargo hose
                        connection and disconnection, including number of hoses
                        and size.
                    </li>
                    <li className="my-2 mx-0">
                        Timing for meetings with port and terminal authorities
                        at arrival and before departure.
                    </li>
                    <li className="my-2 mx-0">Time Free Pratique granted.</li>
                    <li className="my-2 mx-0">
                        Where applicable, timings for tank inspections,
                        sampling, hold inspections.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, timings for cargo calculations, draft
                        surveys.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable,time notice given to engine room to
                        prepare cargo and ballast pumps,inert gas system,
                        nitrogen plants.
                    </li>
                    <li className="my-2 mx-0">
                        Pre-cargo safety meeting with terminal authorities.
                    </li>
                    <li className="my-2 mx-0">
                        Meeting with terminal authorities for a discussion on
                        the cargo handling plan.
                    </li>
                    <li className="my-2 mx-0">
                        Record of any changes made to the cargo handling plan.
                    </li>
                    <li className="my-2 mx-0">
                        Record of any deviations from the cargo handling plan.
                    </li>
                    <li className="my-2 mx-0">
                        On Tankers a statement confirming that lines and valves
                        have been set in accordance with the cargo plan.
                    </li>
                    <li className="my-2 mx-0">
                        Communications with terminal regarding starting and
                        stopping of cargo.
                    </li>
                    <li className="my-2 mx-0">
                        Communications with terminal regarding loading or
                        discharging rates.
                    </li>
                    <li className="my-2 mx-0">
                        Notices given to or received from the terminal for
                        loading or discharging rates.
                    </li>
                    <li className="my-2 mx-0">
                        Timings for when loading or discharging rates are
                        reduced or increased.
                    </li>
                    <li className="my-2 mx-0">
                        Communications with terminal regarding tallying of ship
                        and shore figures for cargo quantities loaded or
                        discharged
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, Start and stop timing for individual
                        cargo pumps, ballast pumps,the inert gas system blower,
                        Nitrogen Plants etc.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, timings for individual tanks/groups of
                        tanks/holds, when:
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                commenced loading/
                                discharging/ballasting/deballasting
                            </li>
                            <li className="my-2 mx-0">
                                stopped
                                loading/discharging/ballasting/deballasting
                            </li>
                            <li className="my-2 mx-0">topped off/stripped</li>
                        </ol>
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, timings for stripping of cargo lines
                        and pumps.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, results of periodic inert gas oxygen
                        and pressure checks - online as well as inindividual
                        tanks.
                    </li>
                    <li className="my-2 mx-0">
                        Results of periodic inspections for compliance with the
                        requirements of the ship - shore safety checklist
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable,results of anti-pollution inspections
                        during cargo work, crude oil washing operations and pre
                        washing of cargo tanks on chemical tankers
                    </li>
                    <li className="my-2 mx-0">
                        Results of periodic pump room inspections.
                    </li>
                    <li className="my-2 mx-0">
                        Timings for vessels or boats coming alongside and
                        purpose.
                    </li>
                    <li className="my-2 mx-0">
                        Results of periodic inspections of moorings when
                        alongside a jetty or the SPM.
                    </li>{' '}
                    <li className="my-2 mx-0">
                        Record of activities carried out by auditors,
                        inspectors, surveyors,terminal representatives.
                    </li>
                    <li className="my-2 mx-0">
                        Ship's figures for quantities
                        loaded/discharged/ballasted/deballasted.
                    </li>
                    <li className="my-2 mx-0">
                        Any unusual occurrences related to the vessel whilst in
                        port.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable, when at sea all tank/hold cleaning
                        operations, inerting, purging or gas freeing of tanks,
                        ballasting or deballasting of tanks, tank entry
                        preparations.
                    </li>
                    <li className="my-2 mx-0">
                        On Oil Tankers the results of the visual checks of the
                        Ballast water surface in the tanks prior' de-ballasting.
                    </li>
                </ol>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);

    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(PortLogEPSCoverPage);
